// Centered Superset wordmark used across the /auth/action screens so the
// password-reset, email-verification, and email-change pages share one header.
const AuthActionHeader = () => (
  <div className="flex flex-col items-center mb-8">
    <img
      className="mx-auto w-16 h-auto"
      src="/superset-icon.png"
      alt="Superset"
    />
    <h1 className="mb-1 mt-1 font-bold leading-7 text-indigo-600 text-4xl tracking-tight">
      Superset
    </h1>
    <span className="font-normal text-med tracking-[1.4px] text-indigo-600">
      Workout Tracker
    </span>
  </div>
);

export default AuthActionHeader;
